module.exports = __webpack_public_path__ + "static/media/chess-clock.784e1ad4.svg";